import styles from "./styles.module.scss";

const AdminIcon = () => {
  return <div className={styles.adminIcon} />;
};

export default AdminIcon;
